import { ChevronRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export interface BreadcrumbItem {
  label: string;
  href?: string;
}

export function Breadcrumb({ items }: { items: BreadcrumbItem[] }) {
  const navigate = useNavigate();

  return (
    <div className="flex items-center gap-1.5 text-sm flex-wrap">
      {items.map((item, i) => {
        const isLast = i === items.length - 1;
        return (
          <div key={i} className="flex items-center gap-1.5">
            {i > 0 && <ChevronRight className="w-3.5 h-3.5 text-gray-400" />}
            {isLast || !item.href ? (
              <span className="text-gray-600 dark:text-gray-300 font-medium">{item.label}</span>
            ) : (
              <button
                className="text-primary-600 dark:text-primary-400 hover:underline font-medium"
                onClick={() => navigate(item.href!)}
              >
                {item.label}
              </button>
            )}
          </div>
        );
      })}
    </div>
  );
}
